import React from 'react';
import styled from 'styled-components';
import dt, { useIsMobile } from '../../../shared/theme';
import useFundsStateStore from '../common/funds-state-hook';

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 24px;
`;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  font-size: 14px;
  line-height: 120%;
  text-transform: uppercase;
  padding: 0 32px;
  border: 1px solid ${props => dt(props).theme.secondaryColor};
  margin-left: -1px;

  ${props => dt(props).theme.isMobile && `
    padding: 0;
    height: 40px;
    width: 42%;
    max-width: 141px;
  `};

  &:first-of-type {
    border-radius: 4px 0 0 4px;
    margin-left: auto;

    ${props => dt(props).theme.isMobile && `
      width: 29%;
      max-width: 97px;
    `};
  }

  &:last-of-type {
    border-radius: 0 4px 4px 0;

    ${props => dt(props).theme.isMobile && `
      width: 29%;
      max-width: 97px;
    `};
  }

  &:hover {
    border: 1px solid ${props => dt(props).theme.bodyColor};
    cursor: pointer;
    z-index: 1;
  }

  &.focus {
    border: 1px solid ${props => dt(props).theme.bodyColor};
    z-index: 1;
  }

  &.active {
    border: 1px solid ${props => dt(props).theme.bodyColor};
    background-color: #EFF1F6;
    z-index: 1;
  }
`;

export default function ViewOptions() {
  const set = useFundsStateStore(state => state.set);
  const currentView = useFundsStateStore(state => state.currentView);

  const setCurrentView = view => (
    set(state => {
      state.currentView = view;
    })
  );

  const isMobile = useIsMobile();
  const performanceViewLabel = `Performance${isMobile ? '' : ' View'}`;
  const feesViewLabel = `Fees${isMobile ? '' : ' View'}`;

  return (
    <Container>
      <OptionContainer className={currentView === 'summary' ? 'active' : ''} onClick={() => setCurrentView('summary')}>
        Summary
      </OptionContainer>
      <OptionContainer className={currentView === 'performance' ? 'active' : ''} onClick={() => setCurrentView('performance')}>
        {performanceViewLabel}
      </OptionContainer>
      <OptionContainer className={currentView === 'fees' ? 'active' : ''} onClick={() => setCurrentView('fees')}>
        {feesViewLabel}
      </OptionContainer>
    </Container>
  );
}
